import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { createPrayerComment, updatePrayerComment } from "../../api/PrayerApi";

function PrayerCommentDialog({ data, onAdd, onUpdate, onCancel }) {
  const [item, setItem] = useState({ ...data }),
    [changes, setChanges] = useState({
      id: data.id,
      prayerId: data.prayerId,
    }),
    [isBusy, setIsBusy] = useState(false),
    handleClose = (_, reason) => {
      if (reason !== "backdropClick") {
        onCancel && onCancel();
      }
    },
    handleInputChange = (e) => {
      const key = e.target.name,
        value = e.target.value;

      updateItem(key, value);
    },
    handleSubmit = (e) => {
      e.preventDefault();

      setIsBusy(true);

      if (changes.id) {
        updatePrayerComment(changes)
          .then((comment) => {
            onUpdate && onUpdate(comment);
            setIsBusy(false);
          })
          .catch(() => {
            setIsBusy(false);
          });
      } else {
        createPrayerComment(changes)
          .then((comment) => {
            onAdd && onAdd(comment);
            setIsBusy(false);
          })
          .catch(() => {
            setIsBusy(false);
          });
      }
    },
    updateItem = (key, value) => {
      let change = {};

      change[key] = value;
      setItem({ ...item, ...change });
      setChanges({ ...changes, ...change });
    };

  return (
    <Dialog fullWidth={true} maxWidth="xs" onClose={handleClose} open={true}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {changes.id ? "Edit Prayer Comment" : "Add a Prayer Comment"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Comment"
            maxRows={10}
            minRows={3}
            multiline
            name="description"
            onChange={handleInputChange}
            required
            sx={{ mt: 1 }}
            value={item.description}
          />
        </DialogContent>
        <DialogActions>
          <Button color="inherit" disabled={isBusy} onClick={handleClose}>
            Cancel
          </Button>
          <Button disabled={isBusy} type="submit" variant="contained">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default PrayerCommentDialog;
